import { Component, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { NotificationService } from './service/notification.service';
import { Routes } from './utils/utils';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [NotificationService],
})
export class AppComponent implements OnInit {
  public menuItems: MenuItem[];
  public showIntroOverlay = false;

  constructor() {}

  ngOnInit(): void {
    this.menuItems = [
      {
        label: 'Spiel',
        routerLink: `/${Routes.HOME}`,
        icon: 'pi pi-dollar',
        command: () => this.closeIntro(),
      },
      {
        label: 'Runden-Statistiken',
        routerLink: `/${Routes.STATISTICS}`,
        icon: 'pi pi-book',
        command: () => this.closeIntro(),
      },
      {
        label: 'Kronen',
        routerLink: `/${Routes.CROWNS}`,
        icon: 'pi pi-info',
        command: () => this.closeIntro(),
      },
      {
        label: 'Spielergebnis speichern',
        routerLink: `/${Routes.ADMIN}`,
        icon: 'pi pi-save',
        command: () => this.closeIntro(),
      },
      {
        label: 'Einstellungen',
        routerLink: `/${Routes.SETTINGS}`,
        icon: 'pi pi-cog',
        command: () => this.closeIntro(),
      },
      {
        label: 'Intro',
        command: () => this.showIntro(),
        icon: 'pi pi-play',
      },
    ];
  }

  public showIntro(): void {
    this.showIntroOverlay = true;
  }

  public closeIntro(): void {
    this.showIntroOverlay = false;
  }
}
